export const t = {
  SET_CURRENT_USER_TOKENS: 'SET_CURRENT_USER_TOKENS',
  SET_CURRENT_USER_DATA: 'SET_CURRENT_USER_DATA',
  LOGUOT: 'LOGUOT',
  SET_CURRENT_USER_MS_STATUS: 'SET_CURRENT_USER_MS_STATUS',
};
